import { getUsStatesShortcodeTemplate } from "../../shortcodes/templates";
import { addShortcodeToEditor, getShortcodeWrapper } from "@/assets/utilities/tinymce/shortodeAddition";
import { states } from "../../../../data/us_states";

const usStatesCTAConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "US States CTA",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "url",
          label: "URL",
          placeholder: "https://domain.com",
        },
        {
          type: "selectbox",
          name: "openLink",
          label: "Open link in...",
          items: [
            { value: "_self", text: "Same window tab" },
            { value: "_blank", text: "New window tab" },
          ],
        },
        {
          type: "selectbox",
          name: "type",
          label: "Button color",
          items: [
            { value: "green", text: "Green" },
            { value: "blue", text: "Blue" },
          ],
        },
      ],
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getUsStatesShortcodeTemplate(states, {
        url: data.url,
        type: data.type,
        tab: data.openLink,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement);
      api.close();
    },
  });
};

export { usStatesCTAConfig };
